class Menu {
    constructor() {
        this.menu = document.getElementById('js-menu');
    }
    init() {
        this.toggleMobileMenu();
    }
    toggleMobileMenu() {
        const toggleButton = document.querySelector(".menu-toggle");
        const navMenu = document.querySelector(".navbar__menu");
        const mobileMenu = () => {
            toggleButton?.classList.toggle("menu-toggle--active");
            navMenu?.classList.toggle("navbar__menu--active");
        };
        toggleButton?.addEventListener("click", mobileMenu);
    }
}
export default new Menu();
